import React from 'react';
import {
  Box,
  Chip,
  Divider,
  Grid,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { formatCurrency } from 'utils/formatter';
import LabelValueBox from 'components/LabelValueBox';
import { tokens } from 'theme/tokens';


const InvoiceModal = ({ invoice }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  invoice = invoice || {};

  const getChipBackgroundColor = (status) => {
    switch (status) {
    case 'RECEIVED':
    case 'RECEIVED_PARTIAL':
      return colors.success.main;
    case 'UNPAID':
      return colors.error.main;
    case 'INVOICED':
      return colors.blue[500];
    }
  };
  return (
    <Box>
      <Grid container spacing={2}>
        <Grid size={{xs: 4, sm: 4}}>
          <LabelValueBox value={invoice.displayOrderId} label='Load Number' />
        </Grid>
        <Grid size={{xs: 4, sm: 4}}>
          <LabelValueBox value={invoice.invoiceDate} label='Invoice Date' />        
        </Grid>
        <Grid size={{xs: 4, sm: 4}}>
          <Box>
            <Typography>
              <Chip size='small' label={invoice.paymentStatus} style={{ color: colors.base.white, backgroundColor: `${getChipBackgroundColor(invoice.paymentStatus)}` }} />
            </Typography>
          </Box>
        </Grid>
        <Grid size={{xs: 4, sm: 4}}>
          <LabelValueBox value={invoice.brokerName} label='Broker' />
        </Grid>
        <Grid size={{xs: 4, sm: 4}}>
          <LabelValueBox value={invoice.brokerReferenceNumber} label='Broker Load Num.' />
        </Grid>
        <Grid size={{xs: 4, sm: 4}}>
          <LabelValueBox value={invoice.containerNumber} label='Container Number' />
        </Grid>
        <Grid size={{xs:12, sm: 6}}>
          <LabelValueBox value={invoice.origins} label='Origins' />
        </Grid>
        <Grid size={{xs:12, sm: 6}}>
          <LabelValueBox value={invoice.destinations} label='Destinations' />          
        </Grid>
        <Grid size={{xs:6, sm: 3}}>
          <LabelValueBox value={formatCurrency(invoice.invoiceTotal)} label='Invoice Total' />          
        </Grid>
        <Grid size={{xs:6, sm: 3}}>
          <LabelValueBox value={formatCurrency(invoice.paymentReceived)} label='Payment Recd.' />
        </Grid>
        <Grid size={{xs:6, sm: 3}}>
          <LabelValueBox value={invoice.checkNumber || '-'} label='Check Number' />
        </Grid>
        <Grid size={{xs:6, sm: 3}}>
          <LabelValueBox value={invoice.paymentReceivedDate} label='Payment Date' />          
        </Grid>
      </Grid>
      <br />
      <br />      
      <Typography variant='subtitle2' sx={{color: colors.neutral[500]}}>Expenses</Typography>
      <Divider />
      {invoice.expenses ?
        <Stack
          spacing={1}
          divider={<Divider flexItem />}
        >
          {invoice.expenses && invoice.expenses.map(exp => (
            <Stack direction={'row'} spacing={1}>
              <LabelValueBox value={exp.name} label={'Expense'} />
              <LabelValueBox value={exp.totalAmount} label={'Amount'} />
              <LabelValueBox value={exp.expenseDate} label={'Date'} />
            </Stack>
          ))}
        </Stack> : <Typography variant='subtitle2' sx={{color: colors}}>{'No Expenses'}</Typography>
      }
    </Box>
  )
};

export default InvoiceModal;